import { QueryClient, keepPreviousData } from '@tanstack/react-query';

export const PERSISTER_KEY = 'comete-link-react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 30 * 60 * 1000, // 30 minutes dans le cache
      retry: 1,
      placeholderData: keepPreviousData,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true
    }
  }
});

/**
 * Vide le cache React Query (mémoire + localStorage persisté).
 * À appeler lors de la déconnexion pour éviter toute fuite de données entre utilisateurs.
 */
export const clearQueryCache = () => {
  queryClient.clear();
  localStorage.removeItem(PERSISTER_KEY);
};
